(function ($) {
    $.fn.simpleToggle = function () {
        $(this).click(function (e) {
            e.preventDefault();
            var toggleTargetId = $(this).data('toggle-target');
            $('#' + toggleTargetId).toggle();
        });
    };
}(jQuery));